/* LBC · Ad landing pages (2026-10-12): bars, rails, tap-to-play videos, sticky phone CTA. */
(function(){
  if(window.LBCADV) return; window.LBCADV=1;
  function ready(f){ if(document.readyState!=='loading') f(); else document.addEventListener('DOMContentLoaded',f); }
  ready(function(){
    /* bars grow once when they scroll into view */
    var ins=document.querySelectorAll('[data-adv-in]');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); },{rootMargin:'0px 0px -12% 0px'});
      ins.forEach(function(el){ io.observe(el); });
    } else ins.forEach(function(el){ el.classList.add('in'); });
    /* rails: arrow buttons scroll one card */
    document.querySelectorAll('[data-adv-rail]').forEach(function(r){
      var t=r.querySelector('.adv-track'); if(!t) return;
      function step(d){ var c=t.firstElementChild; var w=c?c.getBoundingClientRect().width+16:300; t.scrollBy({left:d*w,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); }
      var p=r.querySelector('[data-prev]'), n=r.querySelector('[data-next]');
      if(p) p.addEventListener('click',function(){ step(-1); }); if(n) n.addEventListener('click',function(){ step(1); });
    });
    /* videos load only on tap (keeps the ad landing light) */
    document.addEventListener('click',function(e){
      var b=e.target.closest('[data-adv-vid]'); if(!b) return;
      var src=b.getAttribute('data-adv-vid'); if(!src) return;
      document.querySelectorAll('.adv video').forEach(function(v){ v.pause(); });
      var v=document.createElement('video'); v.src=src; v.controls=true; v.playsInline=true; v.setAttribute('playsinline',''); v.autoplay=true; v.preload='auto';
      b.replaceWith(v); var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){});
    });
    /* sticky CTA on phones: shows once the hero is out of view, hides at the buy block and footer */
    var st=document.querySelector('[data-adv-sticky]'); if(!st||!('IntersectionObserver' in window)) return;
    var hero=st.closest('.adv'), buy=document.querySelector('[data-adv-buy]'), ft=document.querySelector('footer,.lbc-footer'), heroOut=false, buyIn=false, ftIn=false;
    function upd(){ var on=heroOut&&!buyIn&&!ftIn; st.classList.toggle('on',on); st.setAttribute('aria-hidden',on?'false':'true'); var a=st.querySelector('a'); if(a) a.tabIndex=on?0:-1; }
    new IntersectionObserver(function(es){ heroOut=!es[0].isIntersecting; upd(); }).observe(hero);
    if(buy) new IntersectionObserver(function(es){ buyIn=es[0].isIntersecting; upd(); }).observe(buy);
    if(ft) new IntersectionObserver(function(es){ ftIn=es[0].isIntersecting; upd(); }).observe(ft);
  });
})();
